import React from "react";
import AsyncSelect from "react-select/async";
import PropTypes from "prop-types";

// API & Models
import SessionsApi from "../../Classes/API/Administration/SessionsApi";
import searchSessionsReq from "../../Classes/Models/Requests/Administration/CreateSessionReq";
import MDTypography from "components/MDTypography";

const SessionSelector = ({
  patient,
  value,
  onChange,
  placeholder = "Select Session",
  error = false,
}) => {
  const loadSessions = async (inputValue) => {
    if (!patient || Object.keys(patient).length === 0) return [];

    const searchReq = new searchSessionsReq();

    if (patient.getPatient?.contractId) {
      searchReq.ContractId = patient.getPatient.contractId;
    } else {
      searchReq.ContractId = undefined;
      searchReq.IsContractSession = false;
    }

    searchReq.Name = inputValue;
    searchReq.SecretName = inputValue;

    try {
      const res = await SessionsApi.SearchSessions(searchReq);
      if (res.status === "Success") {
        let optionsArr = res.data.list.map((item) => ({
          value: item,
          label: item.name,
        }));

        if (inputValue) {
          optionsArr = optionsArr.filter((item) =>
            item.label.toLowerCase().includes(inputValue.toLowerCase()),
          );
        }
        return optionsArr;
      }
    } catch (error) {
      console.error("Session Search Error:", error);
    }
    return [];
  };

  return (
    <>
      <MDTypography
        variant="caption"
        fontWeight="bold"
        textTransform="uppercase"
        mb={1}
        display="block"
      >
        Select Session
      </MDTypography>
      <AsyncSelect
        key={patient?.id || "no-patient"}
        isClearable
        cacheOptions
        defaultOptions
        loadOptions={loadSessions}
        value={value ? { value: value, label: value.name } : null}
        onChange={(opt) => onChange(opt ? opt.value : null)}
        placeholder={placeholder}
        styles={{
          control: (base) => ({
            ...base,
            minHeight: "44px",
            borderRadius: "8px",
            borderColor: error ? "red" : base.borderColor,
          }),
          menu: (base) => ({ ...base, zIndex: 999 }),
        }}
      />
    </>
  );
};

SessionSelector.propTypes = {
  patient: PropTypes.object,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
};

export default SessionSelector;
